
import { Vue } from "vue-class-component";

export default class FontColor extends Vue {
  changeColor(fontColor: string) {
    this.$store.commit("setFontColor", fontColor);
  }

  changeOpacity(percentage: number) {
    this.$store.commit("setFontOpacity", percentage);
  }
}
